var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5198 7.46666C11.3932 7.46666 11.2665 7.41997 11.1665 7.31997C10.9732 7.12663 10.9732 6.80664 11.1665 6.6133L13.2932 4.48663L11.1665 2.35997C10.9732 2.16663 10.9732 1.84663 11.1665 1.6533C11.3598 1.45997 11.6798 1.45997 11.8731 1.6533L14.3532 4.13332C14.4465 4.22666 14.4998 4.3533 14.4998 4.48663C14.4998 4.61997 14.4465 4.74665 14.3532 4.83999L11.8731 7.31997C11.7731 7.4133 11.6465 7.46666 11.5198 7.46666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.98666H2C1.72667 4.98666 1.5 4.76 1.5 4.48666C1.5 4.21333 1.72667 3.98666 2 3.98666H14C14.2733 3.98666 14.5 4.21333 14.5 4.48666C14.5 4.76 14.2733 4.98666 14 4.98666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47998 14.5C4.35331 14.5 4.22667 14.4533 4.12667 14.3533L1.64665 11.8733C1.55331 11.78 1.5 11.6533 1.5 11.52C1.5 11.3867 1.55331 11.26 1.64665 11.1666L4.12667 8.68666C4.32 8.49332 4.64 8.49332 4.83333 8.68666C5.02667 8.87999 5.02667 9.19999 4.83333 9.39332L2.70667 11.52L4.83333 13.6466C5.02667 13.84 5.02667 14.16 4.83333 14.3533C4.74 14.4533 4.61331 14.5 4.47998 14.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.0133H2C1.72667 12.0133 1.5 11.7867 1.5 11.5133C1.5 11.24 1.72667 11.0133 2 11.0133H14C14.2733 11.0133 14.5 11.24 14.5 11.5133C14.5 11.7867 14.2733 12.0133 14 12.0133Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartArrow);
export default __webpack_public_path__ + "static/media/chart-arrow.dd9a8599d1e88039eef32fff262ac66d.svg";
export { ForwardRef as ReactComponent };